import { z } from "zod";
import { dateRangeSchema } from "./dateRange.schema";
import { quarterAndYearSchema } from "./quarterAndYear.schema";
import { referenceDateParameterSchema } from "./referenceDateParameter.schema";
import { yearSchema } from "./year.schema";

/**
 * Parameter union schema
 */
export const parameterSchema = z.union([
    referenceDateParameterSchema,
    quarterAndYearSchema,
    dateRangeSchema,
    yearSchema,
]);

export type ParameterType = z.infer<typeof parameterSchema>;
